// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box{border:1px solid #c3c4be;margin-bottom:15px;padding:15px}.box.box--focused{border:4px solid #faf2cc;background-color:#fcf8e3;padding:12px}.box__buttons{margin-top:15px}", ""]);
// Exports
module.exports = exports;
